import cn from 'classnames'
import { Form } from 'util/ui'

const Button = ({ primary = true, className, ...rest }) => {
  return (
    <Form.Button
      primary={primary}
      size="big"
      fluid
      className={cn('submit-button', className)}
      {...rest}
    />
  )
}

export default Button
